import { render } from "./MapFooter.vue?vue&type=template&id=37e5a01f&scoped=true&ts=true"
import script from "./MapFooter.vue?vue&type=script&lang=ts"
export * from "./MapFooter.vue?vue&type=script&lang=ts"

import "./MapFooter.vue?vue&type=style&index=0&id=37e5a01f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e5a01f"]])

export default __exports__